export default "__VITE_ASSET__DPV4Ae93__"